<template>
  <div class="hotline-number">
    <h3 class="text-lg mb-4">
      {{$t('common.productTechnicalHotline')}} <span class="text-uppercase">{{product ? `(${product})` : ''}}</span>
    </h3>
    <div class="phone-numbers-container d-flex align-items-start justify-content-start">
      <img src="@/assets/icons/phone.svg" class="filter-to-secondary"/>
      <div class="phone-numbers">
        <div v-if="$i18n.locale === 'bg'">
          <a href="tel:+359888450475">
            <span class="bold">+359 888 450 475</span>&nbsp;
            <country-flag country="ru"/>
            <country-flag country="bg"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'da'">
          <a href="tel:+4576262460">
            <span class="bold">+45 7626 2460</span>&nbsp;
            <country-flag country="dk"/>
            <country-flag country="no"/>
            <country-flag country="se"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'de'">
          <a href="tel:+491621889804">
            <span class="bold">+49 162 188 9804</span> <country-flag country="de"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'es'">
          <a href="tel:+34916744646">
            <span class="bold">+34 916 744 646</span> <country-flag country="es"/>
          </a>
          <a href="tel:+34606212107">
            <span class="bold">+34 606 212 107</span> <country-flag country="es"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'en'">
          <a href="tel:+441695556513">
            <span class="bold">+44 169 555 6513</span> <country-flag country="gb"/>
          </a>
          <a href="tel:+441685559957">
            <span class="bold">+44 168 555 9957</span> <country-flag country="gb"/>
          </a>
          <a href="tel:+4576262460">
            <span class="bold">+45 7626 2460</span>&nbsp;
            <country-flag country="dk"/>
            <country-flag country="no"/>
            <country-flag country="se"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'fr'">
          <a href="tel:+33160860436">
            <span class="bold">+33 1 60 86 04 36</span> <country-flag country="fr"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'gr'">
          <a href="tel:+302310535500">
            <span class="bold">+30 2310 535 500</span> <country-flag country="gr"/>
          </a>
          <a href="tel:+306932252225">
            <span class="bold">+30 6932 252 225</span> <country-flag country="gr"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'nl'">
          <a href="tel:+31683282657">
            <span class="bold">+31 (6) 83282657</span> <country-flag country="nl"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'pl'">
          <a href="tel:+48501292666">
            <span class="bold">+48 501 292 666</span> <country-flag country="pl"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'ru'">
          <a href="tel:+359888450475">
            <span class="bold">+359 888 450 475</span>
            <country-flag country="ru"/>
            <country-flag country="bg"/>
          </a>
        </div>
        <div v-else-if="$i18n.locale === 'se'">
          <a href="tel:+4576262460">
            <span class="bold">+45 7626 2460</span>&nbsp;
            <country-flag country="dk"/>
            <country-flag country="no"/>
            <country-flag country="se"/>
          </a>
        </div>
        <div v-else class="view-default">
          <a href="tel:+4576262460">
            <span class="bold">+45 7626 2460</span>&nbsp;
            <country-flag country="dk"/>&nbsp;
            <country-flag country="no"/>&nbsp;
            <country-flag country="se"/>
          </a>
          <a href="tel:+491621889804">
            <span class="bold">+49 162 188 9804</span> <country-flag country="de"/>
          </a>
          <a href="tel:+441695556513">
            <span class="bold">+44 169 555 6513</span> <country-flag country="gb"/>
          </a>
          <a href="tel:+441685559957">
            <span class="bold">+44 168 555 9957</span> <country-flag country="gb"/>
          </a>
          <a href="tel:+34916744646">
            <span class="bold">+34 916 744 646</span> <country-flag country="es"/>
          </a>
          <a href="tel:+34606212107">
            <span class="bold">+34 606 212 107</span> <country-flag country="es"/>
          </a>
          <a href="tel:+302310535500">
            <span class="bold">+30 2310 535 500</span> <country-flag country="gr"/>
          </a>
          <a href="tel:+306932252225">
            <span class="bold">+30 6932 252 225</span> <country-flag country="gr"/>
          </a>
          <a href="tel:+31683282657">
            <span class="bold">+31 (6) 83282657</span> <country-flag country="nl"/>
          </a>
          <a href="tel:+48501292666">
            <span class="bold">+48 501 292 666</span> <country-flag country="pl"/>
          </a>
          <a href="tel:+359888450475">
            <span class="bold">+359 888 450 475</span>&nbsp;
            <country-flag country="ru"/>&nbsp;
            <country-flag country="bg"/>
          </a>
          <a href="tel:+905332694714">
            <span class="bold">+90 533 269 4714</span> <country-flag country="tr"/>
          </a>
          <a href="tel:+33160860436">
            <span class="bold">+33 1 60 86 04 36</span> <country-flag country="fr"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: String,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.phone-numbers-container {
  img {
    max-width: 50px;
    height: auto;
    @include media-breakpoint-down(md) {
      max-width: 30px;
      margin-top: 3px;
    }
  }
  .phone-numbers {
    padding-left: 20px;
    @include media-breakpoint-down(md) {
      padding-left: 10px;
    }
    a {
      display: block;
      width: fit-content;
      color: $secondary;
    }
    .flag {
      transform: scale(.4);
      box-shadow: 0 0 1rem #b9b9b9;
      border-radius: 0.25rem;
    }
    > div.view-default {
      @extend .text-md;
    }
    > div:not(.view-default) a span:not(.flag) {
      @extend .text-lg;
    }
  }
}
</style>
